import { BreadCrumb } from "../../../Layout/Common/breadCrumb";
import React, { useEffect, useRef, useState } from "react";
import { useNoteAlert } from "../../../Context/pleaseNote";
import { useAuth } from "../../../Context/AuthContext";
import { axiosInstance } from "../../../axios/axiosInstance";
import { CompanyUserTable } from "./companyUserTable";
import { BacktoMyAccount } from "../backToMyAccount";
import { useNavigate, useParams } from "react-router-dom";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
export const CompanyUsers = () => {
  const [UserListData, setUserListData] = useState(null);

  const [DeleteClick, setDeleteClick] = useState(false);
  const [SearchList, setSearchList] = useState("");

  const [filteredList, setFilteredList] = useState([]);
  const { showNoteAlert, showFlashScreen, hideNoteAlert } = useNoteAlert();
  const { isAuthenticated, userId, companyId, setUser, setAthuLoading, emailAddress, role } = useAuth();

  const histroy = useNavigate();
  useEffect(() => {
    handleSearchClick();
  }, [DeleteClick]);

  useEffect(() => {

    if (SearchList == "") {
      setFilteredList(UserListData);
    } else {

      if (SearchList.length > 3) {
        const filtered = UserListData.filter((item) => {
          const CONTACT = item.CONTACT?.toLowerCase() || "";
          const LOGIN_NAME = item.LOGIN_NAME?.toLowerCase() || "";
          const EMAILADDR = item.EMAILADDR?.toLowerCase() || "";
          return (
            CONTACT.includes(SearchList.toLowerCase()) ||
            LOGIN_NAME.includes(SearchList.toLowerCase()) ||
            EMAILADDR.includes(SearchList.toLowerCase())
          );
        });
        setFilteredList(filtered);
      } else {
        setFilteredList(UserListData);
      }
    }
  }, [SearchList]);
  const handleDeleteFun = () => {
    handleSearchClick(); // toggle state to trigger reload
  };
  const handleSearchClick = async () => {
    var data = {
      UserID: userId,
      SearchList: SearchList,
    };
    axiosInstance
      .post("CompanyUsers/CompanyUsers_Load", data)
      .then((response) => {
        if (response.data != "") {
          setUserListData(response.data);
          setFilteredList(response.data);
        }
      })
      .catch((error) => console.log(error.message));

    showFlashScreen(false);
  };
  return (
    <>
      <BreadCrumb
        data={[
          { name: "My Account", url: "/myaccount" },
          { name: "My Company Users", url: "/myaccount/company-users" },
        ]}
      />
      <section className="myAccount-section">
        <div className="container-fluid container-lg" id="divShowDetails" style={{ display: "block" }}>
          <div className="row">
            <div className="col-lg-12">
              <div className="acc-header py-3">
                <div className="myaccount-address myAccount-header">
                  <h1 className="myaccount-title">My Company Users</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="acc-headerInner py-3">
                <div className="acc-header-inner">
                  <h2>Total Users ({filteredList == null ? 0 : filteredList.length})</h2>
                  <p>The list below allows you to edit or delete users</p>
                </div>

                <button
                  type="submit"
                  className="btn btn-products btn-addcart"
                  onClick={() => histroy("/myaccount/company-users-addusers")}
                  style={{ width: "auto" }}
                >
                  Add New User
                </button>
                <div className="fav-search">
                  <div className="input-group orders-search p-0 m-0">
                    <i className="fa-solid fa-magnifying-glass"></i>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search List"
                      value={SearchList}
                      onChange={(e) => {
                        setSearchList(e.target.value);
                      }}
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="myAccountTable">
                <div id="companyUsers_wrapper" className="dataTables_wrapper no-footer">
                  <CompanyUserTable data={filteredList} DeleteFun={handleDeleteFun} />
                </div>
              </div>
            </div>
            <BacktoMyAccount />
          </div>
        </div>
      </section>
    </>
  );
};
